import { isManagerAssessmentSubmitted } from './stepRoutes';

import type { CycleInstance } from '@/types/cycle-evaluation/CycleInstance';

/**
 * Both signals are necessary and neither is sufficient: autosaved drafts land in the same answer list
 * without ever running the submission side effects (score, proficiency history, AI artifacts), and the
 * step counter only moves forward, for reasons that have nothing to do with an answer being saved.
 */
const hasCompletedSurveyAnswer = (cycleInstance?: CycleInstance): boolean =>
    (cycleInstance?.managerAssessmentAnswers?.length ?? 0) > 0 &&
    isManagerAssessmentSubmitted(cycleInstance?.managerAssessmentStep);

const hasRatedCompetency = (cycleInstance?: CycleInstance): boolean =>
    cycleInstance?.assessmentCompetencies?.some(
        (competency) => competency.assessedProficiencyLevelId != null,
    ) ?? false;

const hasRatedCompanyValue = (cycleInstance?: CycleInstance): boolean =>
    cycleInstance?.assessmentCompanyValues?.some(
        (companyValue) => companyValue.assessedProficiencyLevelId != null,
    ) ?? false;

/**
 * Mirrors the server's own predicate (CycleInstanceCrudService.HasSubmittedManagerAssessmentAsync):
 * the evaluation step has three legitimate endings, and an autosaved draft carries none of them.
 */
export const isManagerAssessmentSurveySubmitted = (cycleInstance?: CycleInstance): boolean =>
    hasCompletedSurveyAnswer(cycleInstance) ||
    hasRatedCompetency(cycleInstance) ||
    hasRatedCompanyValue(cycleInstance);
